import React, { Component } from "react";
import MaterialTable from "material-table";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Input,
  Label,
  Form,
  Collapse,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import history from "../../history";
import "react-toastify/dist/ReactToastify.css";
import CartTitle from "../CartTitle";
import FilterCard from "../filterCard";
import Loader from "../Loader";
import get from "lodash/get";
import BranchDetail from "../BranchDetail";
import { fetchQueryParams } from "../../utils/comman";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as sessionActions from "../../redux/Testimonials/action";
import * as globalActions from "../../redux/Global/actions";
import InputText from "../InputText";
import CustomButton from "../CustomButton";
import TestimonialDetails from "../TestimonialDetails";
import AddNewTestimonial from "../AddNewTestimonial";
import moment from "moment";
import config from "../../utils/config";
const _ = { get };

class TestimonialList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleActive: true,
      toggleAddModal: false,
      page: 0,
      pageSize: 10,
      countryCode: "",
      country: "",
      email: "",
      phone: "",
      status: "PENDING",
      prevStatus: "PENDING",
      count: 100,
      selectedId: "",
      toggleModal: false,
      // countryList: [],
      // parsedCountry: "",
      category: "TOUR",
      toggleRejectModal: false,
      rejectionReason: "",
    };
  }

  componentDidMount() {
    let obj = {
      page: this.state.page,
      limit: this.state.count,
      status: this.state.status,
      country: this.state.countryCode,
      state: this.state.state,
      city: this.state.city,
      email: this.state.email,
      phone: this.state.phone,
    };
    this.handleFetchTestimonialList(obj);
    // this.handleSetCountries();
    this.handleFetchTourCountriesJson();
  }

  componentDidUpdate(prevProps, prevState) {
    let countries = JSON.parse(localStorage.getItem("countries"));
    let accessibleCountries = JSON.parse(
      localStorage.getItem("accessCountries")
    );
    console.log(accessibleCountries, countries);
    if (
      prevProps.testimonialsList &&
      prevProps.testimonialsList.length !== this.props.testimonialsList &&
      this.props.testimonialsList.length
    ) {
      let state = this.state;

      state.page = Math.ceil(
        this.props.testimonialsList.length / this.state.count
      );
      this.setState({ ...state });
    }
  }

  handleAddToggleModel = (e) => {
    let newState = { ...this.state };
    newState.toggleAddModal = !newState.toggleAddModal;
    this.setState({ ...newState });
  };

  handleFetchTestimonialList = (payload) => {
    this.props.actions.fetchTestimonialList(payload);
  };

  handleFetchState = (data) => {
    this.props.actions.fetchState(data);
  };

  handleFetchCity = (data) => {
    this.props.actions.fetchCity(data);
  };

  handleFetchTestimonialDetails = (data) => {
    this.props.actions.fetchTestimonialDetails(data);
  };

  handleFetchTourCountriesJson = () => {
    this.props.global.fetchingTestimonialCountriesJson();
  };

  clearingPreviousReducer = (data) => {
    this.props.actions.clearingPreviousReducer(data);
  };

  // handleSetCountries = () => {
  //   let countries = JSON.parse(localStorage.getItem("countries"));
  //   let accessibleCountries = JSON.parse(
  //     localStorage.getItem("accessCountries")
  //   );
  //   console.log(accessibleCountries, countries);
  //   if (accessibleCountries && accessibleCountries[0] === "*") {
  //     let state = this.state;
  //     state.countryList = countries;
  //     console.log("===Star state===", this.state.countryList);
  //     this.setState({ ...state });
  //   }
  //   if (accessibleCountries && accessibleCountries[0] !== "*") {
  //     let state = this.state;
  //     let newCountry = countries.filter((data) =>
  //       accessibleCountries.includes(data.locality.country)
  //     );
  //     state.countryList = newCountry;
  //     let code =
  //       newCountry[0] &&
  //       newCountry[0].locality &&
  //       newCountry[0].locality.country;
  //     let countryName = newCountry && newCountry[0] && newCountry[0].country;

  //     state.countryCode = code;
  //     state.country = countryName;
  //     console.log("===Non Star state===", this.state.countryList);
  //     this.setState({ ...state });
  //   }
  // };

  handleBackCall = () => {
    this.handleFetchTestimonialList({
      page: this.state.page,
      limit: this.state.count,
      status: this.state.status,
      country: this.state.countryCode,
      state: this.state.state,
      city: this.state.city,
      email: this.state.email,
      phone: this.state.phone
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.prevStatus !== this.state.status) {
      let obj = {
        page: this.state.page,
        limit: this.state.count,
        status: this.state.status,
        country: this.state.countryCode,
        state: this.state.state,
        city: this.state.city,
        email: this.state.email,
        phone: this.state.phone,
      };
      let state = this.state;
      state.prevStatus = state.status;
      this.setState({ ...state });
      this.handleFetchTestimonialList(obj);
    }
  }
  handleOnPageChange = (e, page) => {
    let totalPages =
      this.props.testimonialsList &&
      this.props.testimonialsList.length / this.state.pageSize;
    let fetchNextData =
      e >= totalPages - 2 &&
      this.props.testimonialsList &&
      this.props.testimonialsList.length !== 0 &&
      this.props.testimonialsList &&
      this.props.testimonialsList.length < this.props.testimonialsListCount;

    if (fetchNextData === true) {
      let obj = {
        page: this.state.page,
        limit: this.state.count,
        status: this.state.status,
        country: this.state.countryCode,
        state: this.state.state,
        city: this.state.city,
        email: this.state.email,
        phone: this.state.phone,
      };
      this.handleFetchTestimonialList(obj);
    }
  };

  handleOnChange = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  };

  handleOnChangePageSize = (count) => {
    let state = this.state;
    state.pageSize = count;
    this.setState({ ...state });
  };

  handleToggle = (e) => {
    let state = this.state;
    state.toggleActive = !state.toggleActive;
    this.setState({ ...state });
  };

  handleFilterChange = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  };

  handleDelete = (e) => {
    let state = this.state;
    let obj = {
      testimonialId: state.selectedId,
      status: "DELETED",
      rejectionReason: state.rejectionReason,
    };
    this.deleteTourInfo(obj);
  };

  deleteTourInfo = (data) => {
    this.props.actions.deleteTestimonial(data, this.handleGoBack);
  };

  handleGoBack = () => {
    if (
      this.props.usertype === "EU Tours Admin" ||
      this.props.usertype === "Admin"
    ) {
      this.handleRejectModal();
      this.handleToggleModel();
      this.handleFetchTestimonialList({
        page: this.state.page,
        limit: this.state.count,
        status: this.state.status,
        country: this.state.countryCode,
        state: this.state.state,
        city: this.state.city,
        email: this.state.email,
        phone: this.state.phone,
      });
    } else {
      this.handleRejectModal();
      this.handleToggleModel();
      this.handleFetchTestimonialList({
        page: this.state.page,
        limit: this.state.count,
        status: this.state.status,
        country: this.state.countryCode,
        state: this.state.state,
        city: this.state.city,
        email: this.state.email,
        phone: this.state.phone,
      });
    }
  };

  handleChangeStatus = (e) => {
    let state = this.state;
    state.status = e.target.value;
    this.setState({ ...state });
  };

  handleToggleModel = (e) => {
    let newState = { ...this.state };
    newState.toggleModal = !newState.toggleModal;
    this.setState({ ...newState });
  };

  handleRowData = (rowData) => {
    let newState = { ...this.state };
    newState.selectedId = rowData._id;
    newState.toggleModal = !newState.toggleModal;
    this.setState({ ...newState });
  };

  handleCountryChange = (e) => {
    let state = this.state;
    if (e.target.value !== "") {
      state.country = e.target.value;
      // let parsedValue = this.props.tourCountriesJson.filter((item) => {
      //   if (item.country === e.target.value) {
      //     return item.locality.country;
      //   }
      // })[0].locality.country;
      state.countryCode = e.target.value;
    } else {
      state.country = "";
      state.countryCode = "";
    }
    this.setState({ ...state });
  };

  handleSubmitFilter = (e) => {
    e.preventDefault();

    let state = this.state;
    let data = {
      page: 0,
      country: state.country,
      email: state.email.toLowerCase().trim(),
      phone: state.phone.trim(),
      limit: state.count,
      status: state.status,
    };
    if (
      state.countryCode !== "" ||
      state.state !== "" ||
      state.city !== "" ||
      state.email !== "" ||
      state.phone !== "" ||
      state.status !== "" ||
      state.category !== ""
    ) {
      this.handleFetchTestimonialList(data);
      this.clearingPreviousReducer();
    }
  };

  handleClearFilter = () => {
    let state = this.state;
    state.page = 0;
    state.country = "";
    state.countryCode = "";
    state.count = 100;
    state.parsedCountry = "";

    state.email = "";
    state.phone = "";
    state.status = "PENDING";
    state.category = "TOUR";
    this.setState({ ...state });
    let data = {
      page: 0,
      country: "",
      email: "",
      phone: "",
      limit: 100,
      status: "PENDING",
    };
    this.handleFetchTestimonialList(data);
    this.clearingPreviousReducer();
  };

  handleRejectModal = () => {
    let state = this.state;
    state.toggleRejectModal = !state.toggleRejectModal;
    state.rejectionReason = "";
    this.setState({ ...state });
  };

  render() {
    let { elements } = this.props;
    return (
      <React.Fragment>
        <div className="hideSearch custom-m-table mt-4">
          {/* {this.props.fetchingTestimonialsList !== false ? <Loader /> : null} */}
          <Form onSubmit={this.handleSubmitFilter}>
            <Row>
              <Col sm={12}>
                {this.props.usertype &&
                (this.props.usertype === "EU Tours Admin" ||
                  this.props.usertype === "Admin") ? (
                  <CartTitle
                    title={_.get(
                      elements,
                      "euToursElement.testimonialList.headingElement",
                      "Testimonials"
                    )}
                    iconClass={"hideexcel"}
                    Name={_.get(
                      elements,
                      "euToursElement.testimonialList.filterButtonElement",
                      "Filter"
                    )}
                    handleToggle={() => this.handleToggle()}
                    textTitle={_.get(
                      elements,
                      "euToursElement.testimonialList.totalCountElement",
                      "Total Count - "
                    )}
                    preRegisteredUserCount={
                      this.props.testimonialsListCount
                        ? this.props.testimonialsListCount
                        : 0
                    }
                  />
                ) : (
                  <CartTitle
                    title={_.get(
                      elements,
                      "euToursElement.testimonialList.headingElement",
                      "Testimonials"
                    )}
                    iconClass={"hideexcel"}
                    Name={_.get(
                      elements,
                      "euToursElement.testimonialList.addNewElement",
                      "Add New"
                    )}
                    handleToggle={this.handleAddToggleModel}
                    textTitle={_.get(
                      elements,
                      "euToursElement.testimonialList.totalCountElement",
                      "Total Count - "
                    )}
                    preRegisteredUserCount={this.props.testimonialsListCount}
                  />
                )}
              </Col>
              {this.props.usertype && (this.props.usertype === "EU Tours Admin" ||
              this.props.usertype === "Admin") && (
                <Col sm={12}>
                  <Collapse isOpen={this.state.toggleActive}>
                    <Card className="mb-3">
                      <CardBody>
                        <Row>
                          <Col xl={4} lg={4} md={6} sm={6}>
                            <label class="inputLabel">
                              {" "}
                              {_.get(
                                elements,
                                "euToursElement.testimonialList.countryHeadingElement",
                                "Country"
                              )}
                            </label>
                            <FormGroup className=" confirmRiderSelect select_options">
                              {this.props.accessibleCountries &&
                              this.props.accessibleCountries.length === 1 &&
                              this.props.accessibleCountries[0] !== "*" ? (
                                <>
                                  <Input
                                    type="select"
                                    name="City"
                                    className="w-100 customeSelectBtn"
                                    onChange={this.handleCountryChange}
                                    value={this.state.country}
                                  >
                                    <option value="">
                                      {_.get(
                                        elements,
                                        "euToursElement.testimonialList.selectCountryElementt",
                                        "Select Country"
                                      )}
                                    </option>
                                    {this.props.tourCountriesJson &&
                                      this.props.tourCountriesJson.length > 0 &&
                                      this.props.tourCountriesJson
                                        .sort((a, b) =>
                                          a.name > b.name
                                            ? 1
                                            : b.name > a.name
                                            ? -1
                                            : 0
                                        )
                                        .map((item, index) => (
                                          <option
                                            key={index}
                                            value={item.country}
                                          >
                                            {item.country}
                                          </option>
                                        ))}
                                  </Input>
                                </>
                              ) : (
                                <Input
                                  type="select"
                                  name="City"
                                  className="w-100 customeSelectBtn"
                                  onChange={this.handleCountryChange}
                                  value={this.state.country}
                                >
                                  <option value="">
                                    {_.get(
                                      elements,
                                      "euToursElement.testimonialList.selectCountryElementt",
                                      "Select Country"
                                    )}
                                  </option>
                                  {this.props.tourCountriesJson &&
                                    this.props.tourCountriesJson.length > 0 &&
                                    this.props.tourCountriesJson
                                      .sort((a, b) =>
                                        a.name > b.name
                                          ? 1
                                          : b.name > a.name
                                          ? -1
                                          : 0
                                      )
                                      .map((item, index) => (
                                        <option
                                          key={index}
                                          value={item.country}
                                        >
                                          {item.country}
                                        </option>
                                      ))} 
                                  </Input>
                                )}
                              </FormGroup>
                            </Col>
                            {/* <Col xl={4} lg={4} md={6} sm={6}>
                            <FormGroup className=" confirmRiderSelect select_options">
                              <Input
                                type="select"
                                name="branchType"
                                className="w-100 customeSelectBtn"
                                onChange={this.handleStateChange}
                                value={this.state.state}
                              >
                                <option>
                                  {this.state.state !== ""
                                    ? this.state.state
                                    : _.get(
                                        elements,
                                        "dealersListingFilterElements.selectStateLabel",
                                        "Select State"
                                      )}
                                </option>
                                {this.props &&
                                  this.props.states &&
                                  this.props.states
                                    .sort((a, b) =>
                                      a.name > b.name
                                        ? 1
                                        : b.name > a.name
                                        ? -1
                                        : 0
                                    )
                                    .map((item, index) => (
                                      <option
                                        key={index}
                                        value={JSON.stringify(item)}
                                      >
                                        {item}
                                      </option>
                                    ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col xl={4} lg={4} md={6} sm={6}>
                            <FormGroup className=" confirmRiderSelect select_options">
                              <Input
                                type="select"
                                name="branchType"
                                className="w-100 customeSelectBtn"
                                onChange={this.handleCityChange}
                                value={this.state.city}
                              >
                                <option>
                                  {this.state.city !== ""
                                    ? this.state.city
                                    : _.get(
                                        elements,
                                        "dealersListingFilterElements.selectCityLabel",
                                        "Select City"
                                      )}
                                </option>
                                {this.props &&
                                  this.props.cities &&
                                  this.props.cities
                                    .sort((a, b) =>
                                      a.name > b.name
                                        ? 1
                                        : b.name > a.name
                                        ? -1
                                        : 0
                                    )
                                    .map((item, index) => (
                                      <option
                                        key={index}
                                        value={JSON.stringify(item)}
                                      >
                                        {item.cityName}
                                      </option>
                                    ))}
                              </Input>
                            </FormGroup>
                          </Col> */}
                          <Col xl={4}>
                            <InputText
                              labelName={_.get(
                                elements,
                                "euToursElement.testimonialList.emailElement",
                                "Email"
                              )}
                              inputType={"email"}
                              inputName={"email"}
                              InputClass={"inputText"}
                              customValue={this.state.email}
                              inputPlaceholder={_.get(
                                elements,
                                "euToursElement.testimonialList.emailPlaceholder",
                                "Email"
                              )}
                              customOnChange={(e) => this.handleFilterChange(e)}
                            />
                          </Col>
                          <Col xl={4}>
                            <InputText
                              labelName={_.get(
                                elements,
                                "euToursElement.testimonialList.phoneElement",
                                "Phone"
                              )}
                              inputType={"number"}
                              inputName={"phone"}
                              InputClass={"inputText"}
                              customValue={this.state.phone}
                              inputPlaceholder={_.get(
                                elements,
                                "euToursElement.testimonialList.phonePlaceholder",
                                "Phone"
                              )}
                              customOnChange={(e) => this.handleFilterChange(e)}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            lg={12}
                            className="d-flex align-items-center justify-content-end"
                          >
                            <div className="d-flex mt-3">
                              <CustomButton
                                customType={"submit"}
                                name={_.get(
                                  elements,
                                  "euToursElement.testimonialList.searchButtonElement",
                                  "Search"
                                )}
                                customOnChange={(e) =>
                                  this.handleFilterChange(e)
                                }
                              />
                              </div>
                            </Col>
                            <Col xl={4}>
                              <InputText
                                labelName="Phone"
                                inputType={"number"}
                                inputName={"phone"}
                                InputClass={"inputText"}
                                customValue={this.state.phone}
                                inputPlaceholder={_.get(
                                  elements,
                                  "euToursElement.testimonialList.clearFilterButtonElement",
                                  "Clear Filter"
                                )}
                                customOnChange={(e) =>
                                  this.handleFilterChange(e)
                                }
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              lg={12}
                              className="d-flex align-items-center justify-content-end"
                            >
                              <div className="d-flex mt-3">
                                <CustomButton
                                  customType={"submit"}
                                  name={_.get(
                                    elements,
                                    "landingPageElement.searchButtonElement",
                                    "Search"
                                  )}
                                  customClass={
                                    "btn-outline-dark ml-2 bg-none btnthemeColor"
                                  }
                                />
                                <CustomButton
                                  customType={"button"}
                                  name={_.get(
                                    elements,
                                    "landingPageElement.clearFilterButtonElement",
                                    "Clear Filter"
                                  )}
                                  customClass={
                                    "btn-outline-dark ml-2 bg-none btnthemeColor"
                                  }
                                  customClick={this.handleClearFilter}
                                />
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Collapse>
                  </Col>
                )}
              <Col sm={12}>
                <Card className="mb-3">
                  <CardBody>
                    <Row>
                      <Col xl={3} lg={3} md={6} sm={6}>
                        <Label className="inputLabel">
                          {_.get(
                            elements,
                            "euToursElement.testimonialList.statusLabelElement",
                            "Status"
                          )}
                        </Label>
                        <FormGroup className=" confirmRiderSelect select_options">
                          <Input
                            type="select"
                            name="status"
                            className="w-100 customeSelectBtn"
                            onChange={this.handleChangeStatus}
                            value={this.state.status}
                          >
                            <option value={"PENDING"}>
                              {_.get(
                                elements,
                                "euToursElement.testimonialList.pendingElement",
                                "Pending"
                              )}
                            </option>
                            <option value={"APPROVED"}>
                              {_.get(
                                elements,
                                "euToursElement.testimonialList.approvedElement",
                                "Approved"
                              )}
                            </option>
                            <option value={"REJECTED"}>
                              {_.get(
                                elements,
                                "euToursElement.testimonialList.rejectedElement",
                                "Rejected"
                              )}
                            </option>
                            <option value={"MODIFIED"}>
                              {_.get(
                                elements,
                                "euToursElement.testimonialList.modifiedElement",
                                "Modified"
                              )}
                            </option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
          {this.props.usertype &&
          (this.props.usertype === "EU Tours Admin" ||
            this.props.usertype === "Admin") ? (
            <Row>
              <Col sm="12">
                <MaterialTable
                  title=""
                  columns={[
                    {
                      title: _.get(
                        elements,
                        "euToursElement.testimonialList.partnerNameElement",
                        "Partner"
                      ),
                      field: "createdBy",
                      render: (rowData) =>
                        rowData && rowData.createdBy && rowData.createdBy.name,
                    },
                    {
                      title: _.get(
                        elements,
                        "euToursElement.testimonialList.emailElement",
                        "Email"
                      ),
                      field: "createdBy",
                      render: (rowData) =>
                        rowData && rowData.createdBy && rowData.createdBy.email,
                    },
                    {
                      title: _.get(
                        elements,
                        "euToursElement.testimonialList.riderNameElement",
                        "Rider Name"
                      ),
                      field: "author",
                    },
                    {
                      title: _.get(
                        elements,
                        "euToursElement.testimonialList.riderLocationElement",
                        "Rider Location"
                      ),
                      field: "location",
                    },
                    {
                      title: _.get(
                        elements,
                        "euToursElement.testimonialList.postedDateElement",
                        "Posted Date"
                      ),
                      field: "postedDate",
                      render: (rowData) =>
                        rowData &&
                        moment(rowData.postedDate).format("DD-MM-YYYY"),
                    },
                  ]}
                  data={this.props.testimonialsList}
                  options={{
                    actionsColumnIndex: -1,
                    search: false,
                    paging: true,
                    sorting: false,
                    pageSize: this.state.pageSize,
                    paginationType: "stepped",
                    initialPage: 1,
                    showFirstLastPageButtons: false,
                  }}
                  actions={[
                    {
                      icon: "assignment_ind",
                      tooltip: "Detail Page",
                      onClick: (event, rowData) => this.handleRowData(rowData),
                    },
                  ]}
                  onChangeRowsPerPage={(e) => this.handleOnChangePageSize(e)}
                  onChangePage={(e, page) => this.handleOnPageChange(e, page)}
                  localization={{
                    body: {
                      emptyDataSourceMessage: (
                        <h6>
                          {_.get(
                            elements,
                            "euToursElement.testimonialList.noRecordsFoundElement",
                            "No records to display"
                          )}
                        </h6>
                      ),
                    },
                    pagination: {
                      labelRowsSelect: _.get(
                        elements,
                        "euToursElement.EuCustomMaterialTableElement.labelRowsSelect",
                        "rows"
                      ),
                      previousTooltip: _.get(
                        elements,
                        "euToursElement.EuCustomMaterialTableElement.previousTooltip",
                        "previous"
                      ),
                      nextTooltip: _.get(
                        elements,
                        "euToursElement.EuCustomMaterialTableElement.nextTooltip",
                        "next"
                      ),
                    },
                    header: {
                      actions: _.get(
                        elements,
                        "euToursElement.testimonialList.actionsElement",
                        "Actions"
                      ),
                    },
                  }}
                />
              </Col>
            </Row>
          ) : (
            <Row>
              <Col sm="12">
                <MaterialTable
                  title=""
                  columns={[
                    {
                      title: _.get(
                        elements,
                        "euToursElement.testimonialList.riderImageElement",
                        "Rider Image"
                      ),
                      field: "image",
                      render: (rowData) => (
                        <img
                          src={`${config.imageBaseUrl}/${rowData &&
                            rowData.image &&
                            rowData.image.images &&
                            rowData.image.images[0] &&
                            rowData.image.images[0].srcPath}
                    `}
                        />
                      ),
                    },
                    {
                      title: _.get(
                        elements,
                        "euToursElement.testimonialList.riderNameElement",
                        "Rider Name"
                      ),
                      field: "author",
                    },
                    {
                      title: _.get(
                        elements,
                        "euToursElement.testimonialList.riderLocationElement",
                        "Rider Location"
                      ),
                      field: "location",
                    },
                    {
                      title: _.get(
                        elements,
                        "euToursElement.testimonialList.postedDateElement",
                        "Posted Date"
                      ),
                      field: "postedDate",
                      render: (rowData) =>
                        rowData &&
                        moment(rowData.postedDate).format("DD-MM-YYYY"),
                    },
                    {
                      title: _.get(
                        elements,
                        "euToursElement.testimonialList.riderNoteElement",
                        "Rider Note"
                      ),
                      field: "description",
                      render: (rowData) => (
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              rowData.description.length > 100
                                ? rowData.description
                                    .substring(0, 100)
                                    .concat("...")
                                : rowData.description,
                          }}
                        />
                      ),
                    },
                  ]}
                  data={this.props.testimonialsList}
                  options={{
                    actionsColumnIndex: -1,
                    search: false,
                    paging: true,
                    sorting: false,
                    pageSize: this.state.pageSize,
                    paginationType: "stepped",
                    initialPage: 1,
                    showFirstLastPageButtons: false,
                  }}
                  actions={[
                    {
                      icon: "assignment_ind",
                      tooltip: "Detail Page",
                      onClick: (event, rowData) => this.handleRowData(rowData),
                    },
                  ]}
                  onChangeRowsPerPage={(e) => this.handleOnChangePageSize(e)}
                  onChangePage={(e, page) => this.handleOnPageChange(e, page)}
                  localization={{
                    body: {
                      emptyDataSourceMessage: (
                        <h6>
                          {_.get(
                            elements,
                            "euToursElement.testimonialList.noRecordsFoundElement",
                            "No records to display"
                          )}
                        </h6>
                      ),
                    },
                    pagination: {
                      labelRowsSelect: _.get(
                        elements,
                        "euToursElement.EuCustomMaterialTableElement.labelRowsSelect",
                        "rows"
                      ),
                      previousTooltip: _.get(
                        elements,
                        "euToursElement.EuCustomMaterialTableElement.previousTooltip",
                        "previous"
                      ),
                      nextTooltip: _.get(
                        elements,
                        "euToursElement.EuCustomMaterialTableElement.nextTooltip",
                        "next"
                      ),
                    },
                    header: {
                      actions: _.get(
                        elements,
                        "euToursElement.testimonialList.actionsElement",
                        "Actions"
                      ),
                    },
                  }}
                />
              </Col>
            </Row>
          )}
          <Modal
            isOpen={this.state.toggleModal}
            toggle={this.handleToggleModel}
            backdrop={true}
            centered={true}
            size="xl"
            className="modal_main"
          >
            <ModalBody>
              <TestimonialDetails
                selectedId={this.state.selectedId}
                handleBackCall={this.handleBackCall}
                testimonialsDetailsData={this.props.testimonialsDetailsData}
                handleFetchTestimonialDetails={
                  this.handleFetchTestimonialDetails
                }
                handleToggleModel={this.handleToggleModel}
                handleRejectModal={this.handleRejectModal}
              />
            </ModalBody>
          </Modal>
          <Modal
            isOpen={this.state.toggleAddModal}
            toggle={this.handleAddToggleModel}
            backdrop={true}
            centered={true}
            size="xl"
            className="modal_main"
          >
            <ModalBody>
              <AddNewTestimonial
                handleToggleModel={this.handleAddToggleModel}
                handleFetchTestimonialList={this.handleFetchTestimonialList}
              />
            </ModalBody>
          </Modal>
          <Modal
            isOpen={this.state.toggleRejectModal}
            backdrop={true}
            centered={true}
          >
            <ModalHeader toggle={this.handleRejectModal}>
              {_.get(
                elements,
                "euToursElement.testimonialList.rejectionModelLabel",
                "Rejection Reason"
              )}
            </ModalHeader>
            <ModalBody>
              <InputText
                inputType={"textarea"}
                inputName={"rejectionReason"}
                customValue={this.state.rejectionReason}
                customOnChange={(e) => this.handleOnChange(e)}
              />
            </ModalBody>
            <ModalFooter>
              <CustomButton
                customType={"submit"}
                name={_.get(
                  elements,
                  "euToursElement.testimonialList.rejectModelButtonElement",
                  "Reject"
                )}
                customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                customClick={(e) => this.handleDelete(e)}
              />
            </ModalFooter>
          </Modal>
        </div>
      </React.Fragment>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
    global: bindActionCreators(globalActions, dispatch),
  };
}

function mapStateToProps(state) {
  console.log({ state: state.User });
  return {
    fetchingTestimonialsList: state.Testimonials.fetchingTestimonialsList,
    testimonialsList: state.Testimonials.testimonialsList,
    testimonialsListCount: state.Testimonials.testimonialsListCount,
    tourCountriesJson: state.Global.tourCountriesJson,
    testimonialCountriesJson: state.Global.testimonialCountriesJson,
    accessibleCountries: state.Auth.userProfile.accessibleCountries,
    stateStatus: state.Testimonials.stateStatus,
    states: state.Testimonials.states,
    cityStatus: state.Testimonials.cityStatus,
    cities: state.Testimonials.cities,
    testimonialsDetailsStatus: state.Testimonials.testimonialsDetailsStatus,
    testimonialsDetailsData: state.Testimonials.testimonialsDetailsData,
    usertype: state.Auth.usertype,
    elements: state.Elements.elements,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TestimonialList)
);
